export function getCurrentPack(photoCount, packs = []) {
  if (!photoCount || !packs.length) {
    return null;
  }

  return packs.find((pack) => pack.quantity === photoCount) || null;
}